import React from 'react';
import Select from 'react-select';
import COUNTRIES_ISO from '../Countries';

export const countryOptions = COUNTRIES_ISO.map(c => ({
  value: c.alpha3,
  label: c.name,
  flagUrl: `https://cdn.anubesport.com/timing/flags/${c.alpha2.toLowerCase()}.png`,
}));

const CountrySelect = ({ value, onChange }) => {
  const selected = value ? (countryOptions.find(o => o.value === value) || null) : null;
  const formatOptionLabel = (option) => (
    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
      <img src={option.flagUrl} style={{ width: '22px', height: '14px', objectFit: 'cover', flexShrink: 0 }} alt='' />
      <span>{option.label}</span>
    </div>
  );
  return (
    <Select
      options={countryOptions}
      value={selected}
      onChange={opt => onChange(opt ? opt.value : '')}
      formatOptionLabel={formatOptionLabel}
      placeholder='— country —'
      isClearable
      menuPortalTarget={document.body}
      styles={{
        menuPortal: base => ({ ...base, zIndex: 9999 }),
        control: (base, state) => ({
          ...base,
          background: 'transparent',
          border: 'none',
          borderBottom: '1px solid #aaa',
          borderRadius: 0,
          boxShadow: 'none',
          minHeight: 'unset',
          fontFamily: 'Verdana',
          fontSize: '0.85em',
          cursor: 'pointer',
          paddingLeft: 0,
        }),
        valueContainer: base => ({ ...base, padding: '0 4px 0 0' }),
        indicatorSeparator: () => ({ display: 'none' }),
        dropdownIndicator: base => ({ ...base, padding: '0 4px' }),
        clearIndicator: base => ({ ...base, padding: '0 4px' }),
        option: (base, state) => ({
          ...base,
          fontFamily: 'Verdana',
          fontSize: '0.85em',
          background: state.isFocused ? '#e8f0fe' : '#fff',
          color: '#222',
          cursor: 'pointer',
        }),
        menu: base => ({ ...base, zIndex: 9999 }),
      }}
    />
  );
};

export default CountrySelect;
